/* --------------------------------------------------------------------------------------
   scanQueuesProvider.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

import { createContext } from 'preact'
import { useState, useContext } from 'preact/hooks'
import { errorContext } from './errorProvider'


export const scanQueuesContext = createContext()

const ScanQueuesProvider = ({ children }) => {
  const [scanQueues, setScanQueues] = useState([])
  const [hasMoreScanQueues, setHasMoreScanQueues] = useState(false)
  const [hasTotalMoreThanPageSize, setHasTotalMoreThanPageSize] = useState(false)
  const [selectedQueue, setSelectedQueue] = useState()
  const [loading, setLoading] = useState(false)

  const resetScanQueues = () => setScanQueues([])
  const contextElements = {
    loading,
    setLoading,
    scanQueues,
    setScanQueues,
    hasTotalMoreThanPageSize,
    setHasTotalMoreThanPageSize,
    hasMoreScanQueues,
    setHasMoreScanQueues,
    resetScanQueues,
    selectedQueue,
    setSelectedQueue
  }

  return (
    <scanQueuesContext.Provider value={contextElements}>
      {children}
    </scanQueuesContext.Provider>
  )
}

export default ScanQueuesProvider
